import React from 'react';
import renderHTML from 'react-render-html';
import { Button } from 'telstra-ui/components/button/Button';
import { formatNumber } from '../../../../app-actions';
import './display-cost-and-data-allowance.css';

const DisplayCostAndDataAllowance = (props) => {
  const {
    authorableContent: {
      totalCostText,
      totalDataText,
      gbText,
      saveText,
      forText,
      extraDataText,
      getText,
      submitButtonText,
    },
    planListData,
    recommendSection,
    optimize,
    optimizeTotalCost,
    optimizeTotalData,
    requestCallBackBtn,
    saveMoney,
    dataBenefit,
    onSubmitButton,
    currentTotalCost,
    currentTotalData,
  } = props;

  const calulatetotalCost = () => {
    let totalcost = 0;
    planListData.map((data) => {
      if (data.numberOfDevices > 0 && data.numberOfDevices !== '' && data.cost > 0 && data.cost !== '') {
        totalcost += parseInt(data.numberOfDevices, 10) * parseInt(data.cost, 10);
      }
      return totalcost;
    });
    return formatNumber(totalcost);
  };

  const calulatetotalDataAllowance = () => {
    let totalDataAllowance = 0;
    planListData.map((data) => {
      if (data.numberOfDevices > 0 && data.numberOfDevices !== '' && data.dataAllowance > 0 && data.dataAllowance !== '') {
        totalDataAllowance += parseInt(data.numberOfDevices, 10) * parseInt(data.dataAllowance, 10);
      }
      return totalDataAllowance;
    });
    return formatNumber(totalDataAllowance);
  };

  const getBenefitHtmlText = () => {
    let benefitHtml = '';
    if (saveMoney > 0 && dataBenefit > 0) {
      benefitHtml = `${saveText} <b class='benefit-text'>$${saveMoney}</b> ${forText} <b class='benefit-text'>${dataBenefit}GB</b> ${extraDataText}`;
    } else if (saveMoney > 0) {
      benefitHtml = `${saveText} <b class='benefit-text'>$${saveMoney}</b>`;
    } else if (dataBenefit > 0) {
      benefitHtml = `${getText} <b class='benefit-text'>${dataBenefit}GB</b> ${extraDataText}`;
    }

    return benefitHtml;
  };

  const getBenefitHtmlTextPlanByPlan = () => {
    console.log('calling getBenefitHtmlTextPlanByPlan');
    let totalcost = 0;
    planListData.map((data) => {
      if (data.numberOfDevices > 0 && data.numberOfDevices !== '' && data.cost > 0 && data.cost !== '') {
        totalcost += parseInt(data.numberOfDevices, 10) * parseInt(data.cost, 10);
      }
      return totalcost;
    });

    let totalDataAllowance = 0;
    planListData.map((data) => {
      if (data.numberOfDevices > 0 && data.numberOfDevices !== '' && data.dataAllowance > 0 && data.dataAllowance !== '') {
        totalDataAllowance += parseInt(data.numberOfDevices, 10) * parseInt(data.dataAllowance, 10);
      }
      return totalDataAllowance;
    });

    const saveMoneyPlan = currentTotalCost - totalcost;
    const dataBenefitPlan = totalDataAllowance - currentTotalData;

    let benefitHtml = '';
    if (saveMoneyPlan > 0 && dataBenefitPlan > 0) {
      benefitHtml = `${saveText} <b class='benefit-text'>$${saveMoney}</b> ${forText} <b class='benefit-text'>${dataBenefit}GB</b> ${extraDataText}`;
    } else if (saveMoneyPlan > 0) {
      benefitHtml = `${saveText} <b class='benefit-text'>$${saveMoney}</b>`;
    } else if (dataBenefitPlan > 0) {
      benefitHtml = `${getText} <b class='benefit-text'>${dataBenefit}GB</b> ${extraDataText}`;
    }

    return benefitHtml;
  };

  return (
    <div className="cost-data-allowance-section marginXS ml-0 mr-0">
      <div className="row">
        <div className={`col-md-4 cost-section ${recommendSection ? 'recommend-color' : ''}`}>
          <div className="col-12 p-d-0 cost heading44">
            $ {optimize ? formatNumber(optimizeTotalCost) : calulatetotalCost()}
          </div>
          <div className="col-12 p-d-0 title">
            {totalCostText}
          </div>
        </div>
        <div className={`col-md-4 data-section ${recommendSection ? 'recommend-color' : ''}`}>
          <div className="col-12 p-d-0 data heading44">
            {optimize ? formatNumber(optimizeTotalData) : calulatetotalDataAllowance()} {gbText}
          </div>
          <div className="col-12 p-d-0 title">
            {totalDataText}
          </div>
        </div>
        {requestCallBackBtn &&
          <React.Fragment>
            <div className="col-md-5 benefit-text-section recommend-color-darker">
              {optimize ? renderHTML(getBenefitHtmlText()) : renderHTML(getBenefitHtmlTextPlanByPlan())}
            </div>
            <div className="col-md-3 recommend-color-darker">
              <Button
                variant="super"
                onClick={onSubmitButton}
                state={'app'}
                className="float-right"
              >
                {submitButtonText}
              </Button>
            </div>
          </React.Fragment>
        }
      </div>
    </div>
  );
};

export default DisplayCostAndDataAllowance;
